module.exports = __webpack_public_path__ + "assets/img/social/instagram-icon.8fc15e82c982a5bfbb38c574d9505e2b.svg";